<template>
  <div v-show="isActive" :class="{ widgetContainer: !isFixed }" :id="isFixed ? 'searchIDFix' : 'searchID'">
    <div v-if="!isFixed" class="map-tool-window-header" :class="{ widgetHeader: !isFixed }" id="searchIDheader">
         <p class="map-tool-window-header-title">Buscador</p>
          <div class="map-tool-window-header-actions">
            <button class="control-btn" v-on:click="isHidden = !isHidden">
              <!-- <font-awesome-icon v-if="!isHidden" icon="minus"></font-awesome-icon>
              <font-awesome-icon v-else icon="plus"></font-awesome-icon> -->
            <svg  v-if="isHidden"
            viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            <svg v-else
              viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12"/></svg>
            </button>
            <button class="control-btn" v-on:click="exitSearch()">
              <svg viewBox="0 0 24 24"><line x1="5" y1="5" x2="19" y2="19"/><line x1="19" y1="5" x2="5" y2="19"/></svg>
              <!-- <font-awesome-icon icon="times" v-on:click="exitSearch()"></font-awesome-icon> -->
            </button>
        </div>
    </div>

    <div class="search-filters">
      <label>Filtrar por tipo:</label>
      <select v-model="placeTypeFilter" @change="applyFilter">
        <option value="all">Todos los lugares</option>
        <option value="city">Ciudades</option>
        <option value="country">Países</option>
        <option value="state">Regiones/Estados</option>
      </select>
    </div>

    <div :class="{ widgetBody: !isFixed }" style="max-width: min-content;" v-show="!isHidden">
      <div :class="{ resizable: !isFixed }">
        <div>
          <AutoCompleteInput ref="autoCompleteInput" id="location" v-bind:value="searchInput"
            v-bind:options="searchList" @updated="waitForSearch" @itemSelected="setLocation"
            v-bind:attribute="'formatted_display'" v-bind:beforeSearchMessage="'Ingresa una ciudad o país'"
            v-bind:searchingMessage="'Buscando lugares...'"
            v-bind:emptySearchResultsMessage="'No se encontró ningún lugar con ese nombre'" v-bind:error="searchError">
          </AutoCompleteInput>

          <div class="place-info">
            <div v-if="searchLocation">
              <div class="place-title">
                <img src="images/marker.svg">
                <p>Lugar encontrado</p>
              </div>
              <p class="place-name">{{ searchLocation.display_name }}
                <span v-if="searchLocation.category" class="place-category">{{ searchLocation.category }}</span>
              </p>
              <p>
                <span class="place-lat-lon">Latitud:</span>
                <span>{{ searchLocation.lat }}</span>
              </p>
              <p>
                <span class="place-lat-lon">Longitud:</span>
                <span>{{ searchLocation.lon }}</span>
              </p>
              <!-- Mostrar país si está disponible -->
              <p v-if="searchLocation.address && searchLocation.address.country">
                <span class="place-lat-lon">País:</span>
                <span>{{ searchLocation.address.country }}</span>
              </p>
            </div>

            <div v-else>
              <div class="place-title">
                <img src="images/marker.svg">
                <p>Resultados búsqueda</p>
              </div>
              <p class="place-name">No hay resultados para mostrar</p>
            </div>
          </div>
        </div>

        <div>
          <button class="btn btn-secondary btn-clean" style="margin-top: 0.5em;" v-if="searchLocation"
            v-on:click="cleanSearch()">Limpiar búsqueda</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AutoCompleteInput from '@/components/mapTools/search/AutoCompleteInput.vue'
import { draggableDiv } from '@/components/mixin/draggableDiv.js'
import { vuex } from '@/components/mixin/vuex.js'
import { mapService } from '@/services/map/mapService.js'
import { search } from './search.js'


export default {
  name: 'HelloWorld',
  props: ['isFixed'],
  mixins: [vuex, draggableDiv, search],
  data() {
    return {
      map: null,
      isHidden: false,
      searchInput: '',
      searchList: [],
      searchLocation: '',
      timeout: null,
      searchError: false,
      placeTypeFilter: 'all',
    }
  },
  components: {
    AutoCompleteInput
  },
  computed: {
    isActive: function () {
      return this.isFixed ? this.isMobile : this.mapToolValues('search').active && !this.isMobile
    }
  },
  methods: {
    applyFilter: function () {
      if (this.searchInput && this.searchInput.trim() !== '') {
        this.searchQuery(this.searchInput);
      }
    },
    searchQuery: function (query) {
      this.searchError = false;

      // URL base del servicio
      const nominatimUrl = process.env.VUE_APP_API_NOMINATIM;

      // Parámetros para optimizar búsqueda de ciudades y países
      const params = new URLSearchParams({
        format: 'json',
        q: query,
        addressdetails: 1,     // Obtener detalles del domicilio
        limit: 10,             // Limitar a 10 resultados
        featuretype: 'city,country,state' // Filtrar por tipo de lugar
      });

      // Construir la URL completa
      const url = `${nominatimUrl}search?${params.toString()}`;

      console.log("Buscando lugares:", url);

      var req = new XMLHttpRequest();
      req.open('GET', url, false);
      req.withCredentials = false;
      req.send();

      if (req.status == 200) {
        console.log("Búsqueda exitosa");
        const response = JSON.parse(req.response);

        if (response.length === 0) {
          console.log("No se encontraron resultados");
          this.searchError = true;
          this.searchList = [];
          return;
        }

        // Procesar y enriquecer los resultados
        this.searchList = response.map(place => {
          // Extraer información relevante
          const type = place.type || '';
          const category =
            type.includes('city') ? 'Ciudad' :
              type.includes('administrative') ? 'Región/Estado' :
                type.includes('country') ? 'País' :
                  'Lugar';

          // Crear un nombre más descriptivo
          let displayName = place.display_name;
          // Si tenemos detalles de la dirección, crear un nombre más limpio
          if (place.address) {
            const parts = [];

            if (place.address.city) parts.push(place.address.city);
            else if (place.address.town) parts.push(place.address.town);
            else if (place.address.village) parts.push(place.address.village);

            if (place.address.state) parts.push(place.address.state);
            if (place.address.country) parts.push(place.address.country);

            if (parts.length > 0) {
              displayName = parts.join(', ');
            }
          }

          return {
            ...place,
            category,
            display_name: displayName,
            // Campos para mostrar en resultados
            // formatted_display: `${displayName} <small class="text-muted">(${category})</small>`
            formatted_display: displayName
          };
        });

        console.log("Resultados procesados:", this.searchList);
      } else {
        console.error("Error en la búsqueda:", req.status);
        this.searchError = true;
        this.searchList = [];
      }
    },
    waitForSearch: function (newValue) {
      this.searchInput = newValue;
    },
    setLocation: function (location) {
      this.searchLocation = location;
      this.executeMapToolAction('search', 'setLocation', {
        lat: location.lat,
        lon: location.lon
      })
      this.addLocationMarker(location.lat, location.lon)
    },
    exitSearch: function () {
      this.cleanSearch()
      this.selectMapTool('search', false)
    },
    cleanSearch: function () {
      this.$refs.autoCompleteInput.setQuery('')
      this.executeMapToolAction('search', 'removeLocation', {})
      if (this.removeLoationMarker) {
        this.removeLoationMarker();
      }
    }
  },
  updated() {

  },
  created() {

  },
  mounted() {
    this.makeDraggable("searchID");
    this.map = mapService.get();
  },
  watch: {
    'searchInput': function (newValue, oldValue) {

      if (newValue == '') {
        this.searchList = [];
        this.searchLocation = null;
        this.$emit('onRemoveLocation');
        return;
      }

      clearTimeout(this.timeout);
      // Make a new timeout set to go off in 800ms
      this.timeout = setTimeout(function () {
        this.searchQuery(newValue);
      }.bind(this), 501);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.place-category {
  font-size: 0.8em;
  background-color: #f0f0f0;
  padding: 2px 6px;
  border-radius: 4px;
  margin-left: 5px;
  color: #666;
}

.resizable {
  margin-top: 0.5em;
  height: 30vh;
  min-height: 10vh;
  min-width: 20vw;
  resize: both;
  overflow: auto;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.place-info {
  .place-title {
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 1.25em;

    img {
      width: 1.25em;
      height: 1.25em;
    }
  }

  .place-name {
    //font-size: 1.0625em;
    //color: #006FB3;
  }

  .place-lat-lon {
    color: #006FB3;
  }

  span {
    //font-weight: bold;
  }
}
</style>
